/* S1 Test Bars: fade-ins + grow the bar fills on first scroll-in (same
   IntersectionObserver contract as the other s1 landing sections). */

class S1TestBars extends HTMLElement {
  connectedCallback() {
    if (!this._io) {
      this._io = new IntersectionObserver((entries) => {
        entries.forEach((en) => {
          if (!en.isIntersecting) return;
          en.target.classList.add(en.target.hasAttribute('data-tbars-fill') ? 'is-grown' : 'is-visible');
          this._io.unobserve(en.target);
        });
      }, { threshold: 0.2 });
    }
    this.querySelectorAll('.s1-tbars-fade:not(.is-visible), [data-tbars-fill]:not(.is-grown)').forEach((el) => this._io.observe(el));
  }

  disconnectedCallback() {
    if (this._io) this._io.disconnect();
  }
}

if (!customElements.get('s1-test-bars')) {
  customElements.define('s1-test-bars', S1TestBars);
}
